import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./lib/api";

const SiteSettingsContext = createContext({});

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get("/settings").then(({ data }) => setSettings(data || {})).catch(() => {});
  }, []);
  return <SiteSettingsContext.Provider value={settings}>{children}</SiteSettingsContext.Provider>;
};

export const useSettings = () => useContext(SiteSettingsContext);
